const url = process.env.REACT_APP_API_URL;

export const Constants = {
    url: url,
    baseUrl: url + "/api/admin",
};

export const ESPECIALIDADES = [
	'Analista comportamental',
	'Aplicador ABA',
	'Arteterapeuta',
	'Assistente terapêutico (AT)',
	'Babá / Cuidador',
	'Educador físico',
	'Equoterapeuta',
	'Fisioterapeuta',
	'Fonoaudiólogo',
	'Mediador',
	'Musicoterapeuta',
	'Neuropediatra',
	'Neuropsicólogo',
	'Neuropsicopedagogo',
	'Nutricionista ',
	'Nutrólogo ',
	'Odontopediatra',
	'Pedagogo',
	'Pediatra',
	'Professor',
	'Psicólogo',
	'Psicomotricista',
	'Psicopedagogo',
	'Psiquiatra',
	'Terapeuta ocupacional',
	'Outro',
];